import { render } from "./PKHomeView.vue?vue&type=template&id=00a98b0a&scoped=true"
import script from "./PKHomeView.vue?vue&type=script&lang=js"
export * from "./PKHomeView.vue?vue&type=script&lang=js"

import "./PKHomeView.vue?vue&type=style&index=0&id=00a98b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a98b0a"]])

export default __exports__